import { flow, Instance, types } from 'mobx-state-tree'
import { addFile } from '../../network/addFile'
import { checkDeleteFile } from '../../network/checkDeleteFile'
import { checkUpdateFile } from '../../network/checkUpdateFile'
import { deleteExcelFile } from '../../network/deleteExcelFile'
import {
  downloadFinhubReportApi,
  generateFinHubReport,
  getGenerateFinHubReportReq,
} from '../../network/downloadFinhubReport'
import { fileProcessApprovals } from '../../network/fileProcessApprovals'
import { generateExcelFile } from '../../network/generateExcelFile'
import { getAllByFile } from '../../network/getAllByFile'
import { getFileNames } from '../../network/getFileNames'
import { getFiles } from '../../network/getFiles'
import { getFilesById } from '../../network/getFilesById'
import { updateFile } from '../../network/updateFile'
import { getErrorMessage, MessageTypes, waitInterval } from '../../utils'
import { FORM_MESSAGE } from '../../utils/constants'
import { RootStore } from '../store'

const ExcelFile = types.model('ExcelFile', {
  type: types.optional(types.literal('excelFile'), 'excelFile'),
  id: types.optional(types.string, ''),
  fileName: types.optional(types.string, ''),
  rules: types.optional(types.string, ''),
})

const GenerateExcelFile = types
  .model('GenerateExcelFile', {
    excelFile: types.optional(ExcelFile, {}),
    excelFiles: types.array(ExcelFile),
    fileNames: types.array(types.string),
    instrumentFilenames: types.array(types.string),
  })
  .actions((self) => ({
    getById: flow(function* getById(id: number) {
      try {
        const response = yield getFilesById(id, RootStore.session.getTokens)
        const own = self
        own.excelFile = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    add: flow(function* add(data: any) {
      try {
        const response = yield addFile(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    deleteFile: flow(function* deleteFile(data: any) {
      try {
        const response = yield deleteExcelFile(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    processApprovals: flow(function* processApprovals(data: any) {
      try {
        const response = yield fileProcessApprovals(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    update: flow(function* update(data: any) {
      try {
        const response = yield updateFile(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    fetchFileNames: flow(function* fetchFileNames() {
      try {
        const response = yield getFileNames(RootStore.session.getTokens)
        const own = self
        own.instrumentFilenames = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    checkUpdate: flow(function* checkUpdate(data: any) {
      try {
        const response = yield checkUpdateFile(data, RootStore.session.getTokens)
        // RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    checkDelete: flow(function* checkDelete(data: any) {
      try {
        const response = yield checkDeleteFile(data, RootStore.session.getTokens)
        // RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    generateFile: flow(function* generateFile(data: any) {
      try {
        const response = yield generateExcelFile(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    fetchAllByFile: flow(function* fetchAllByFile(fileName: string) {
      try {
        const response = yield getAllByFile(fileName, RootStore.session.getTokens)
        const own = self
        own.excelFile = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    fetchFiles: flow(function* fetchFiles() {
      try {
        const response = yield getFiles(RootStore.session.getTokens)
        const own = self
        own.fileNames = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    poolDownloadFinhubReport: flow(function* poolDownloadFinhubReport(noOfRetry: number, fileName: string) {
      try {
        if (noOfRetry < 100) {
          const resp = yield downloadFinhubReportApi(fileName, RootStore.session.getTokens)
          let jsonResp
          try {
            console.log('resp', resp)
            if (resp?.data?.byteLength <= 100) {
              jsonResp = JSON.parse(new TextDecoder('utf-8').decode(resp?.data))
            }
          } catch (err) {
            console.log(err)
            throw err
          }
          if ((jsonResp && jsonResp?.status === 'PENDING') || resp?.data?.status === 'PENDING') {
            yield waitInterval(2000)
            return yield (self as any).poolDownloadFinhubReport(noOfRetry + 1, fileName)
          } else if (jsonResp) {
            throw { message: 'Please try after sometime.' }
          }
          if (window && resp && resp?.data) {
            let mimeType: BlobPropertyBag = resp.headers['Content-Type']
            const blob = new Blob([resp?.data], {
              mimeType,
            })
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = fileName
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }
          return resp
        } else {
          throw { message: 'Please try after sometime.' }
        }
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    downloadFinhubReport: flow(function* downloadFinhubReport(month: string, year: string) {
      try {
        const payload = getGenerateFinHubReportReq(month, year)
        const response = yield generateFinHubReport(payload, RootStore.session.getTokens)
        if (response.status === 'INITIATED') {
          const resp = yield (self as any).poolDownloadFinhubReport(0, response?.fileName)
        } else {
          throw { message: 'an error has occoured' }
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getFileNames() {
      return self.fileNames.map((item, index) => ({
        id: '' + index + 1,
        value: item,
      }))
    },
    getInstrumentFileNames() {
      return self.instrumentFilenames.map((item, index) => ({
        id: '' + index + 1,
        value: item,
      }))
    },
    getFileData(fileName: string) {
      const dt = {
        ...self.excelFile,
        rules: self.excelFile.rules,
        generateFile: 'Generate Excel',
      }

      return self.excelFile.id && self.excelFile.fileName === fileName ? dt : null
    },
  }))

const excelFileData = GenerateExcelFile.create({
  excelFile: {},
  excelFiles: [],
  fileNames: [],
})

export type GenerateExcelFileType = Instance<typeof GenerateExcelFile>
export type ExcelFileType = Instance<typeof ExcelFile>
export { ExcelFile, excelFileData, GenerateExcelFile }
